import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define type for a wishlist item
export interface WishListItem {
  id: number;
  productID: number | string;
  productName: string;
  productPrice: number;
  productReviews: string;
  frontImg: string;
  backImg?: string;
  productDiscount?: number;
}

// Define the initial state type
interface WishListState {
  items: WishListItem[];
}

const initialState: WishListState = {
  items: [],
};

const wishListSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addToWishList: (state, action: PayloadAction<WishListItem>) => {
      state.items.push(action.payload);
    },
    removeFromWishList: (state, action: PayloadAction<{ id: number }>) => {
      state.items = state.items.filter(item => item.id !== action.payload.id);
    },
    clearWishList: (state) => {
      state.items = [];
    },
  },
});

export const { addToWishList, removeFromWishList, clearWishList } =
  wishListSlice.actions;

export default wishListSlice.reducer;
